import { Component, h, useState } from "@lukekaalim/act"
import { html } from "@lukekaalim/act-web"

import classes from './index.module.css';
import { assetURLs } from "../../assets";
import { LabeledInput } from "./input";
import { AuthState } from "../../hooks";

export type LoginProps = {
  onLoginComplete(): void,
  onClickSignUp(): void,
  onClickLogo(): void,

  auth: AuthState,
}

export const Login: Component<LoginProps> = ({ onLoginComplete, onClickSignUp, onClickLogo, auth }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  return h(html.form, { classList: [classes.authenticateForm, classes.login], async onSubmit(event) {
    event.preventDefault();
    console.log(`ON SUBMIT`, auth)
    await auth.login({ usernameOrEmail: username, password })
    onLoginComplete();
  }, }, [

    h(html.img, { className: classes.heroLogo, src: assetURLs.kosmodTransparentLogo, onClick: onClickLogo }),

    h(html.p, { className: classes.instructions }, [
      h(html.div, {}, `Login to your`),
      h(html.strong, {}, `Kosmod Account`)
    ]),

    h(LabeledInput, {
      label: 'username or email',
      name: 'username',
      placeholder: 'luke.kaalim',
      value: username,
      autofocus: true,
      onInput() {
        setUsername(this.value)
      },
    }),
    h(LabeledInput, {
      label: 'password',
      type: 'password',
      placeholder: '************',
      value: password,
      onInput() {
        setPassword(this.value)
      },
    }),
    h(html.input, { type: 'submit' }),

    h(html.div, {}, [
      h(html.div, {}, `dont' have an account?`),
      h(html.button, { onClick: onClickSignUp, type: 'button' }, 'Sign up'),
    ]),
  ])
}